export const GoogleAdsConversion = (value) => {
  window.gtag("event", "conversion", {
    send_to: "AW-470144525/I04yCPThzLoYEI2sl-AB",
    value: value / 100,
    currency: "BRL",
    transaction_id: "",
  });
};
